import { parse } from 'node-html-parser'

import { isInternalUrl, isRelativeUrl } from '@src/Application/Utils/BrowserUtils'

export const updateHtmlElement = ({ content, siteUrl }: { content: string; siteUrl: string }): string => {
    const htmlElement = parse(content)

    htmlElement.querySelectorAll('a').forEach((a) => {
        const href = a.getAttribute('href')

        if (!href) return

        if (!isRelativeUrl(href) && !isInternalUrl({ url: href, siteUrl })) {
            a.setAttribute('target', '_blank')
            a.setAttribute('rel', 'noreferrer noopener')
        }
    })

    return htmlElement.innerHTML
        .replace(/(<del)/gim, '<span class="highlight"')
        .replace(/<\/del>/gim, '</span>')
        .replace(/\n/gim, '<br />')
}
